function select() {
    document.querySelectorAll('.selector').forEach(function(selector) {
        const options = selector.getElementsByClassName("option");
        let selectBtn = selector.querySelector("#customSelector");
        let selectValue = selector.querySelector("#selectedValue");

        function clickSelectBtn() {
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (option.style.display === "block") {
                    option.style.display = "none";
                    selectBtn.classList.remove('open');
                } else {
                    option.style.display = "block";
                    selectBtn.classList.add('open');
                }
            }
        }

        selectBtn.addEventListener('click', clickSelectBtn)

        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            option.addEventListener('click', () => {
                selectBtn.innerHTML = option.innerHTML;
                selectValue.value = i;
                clickSelectBtn();
            })
        }
    })
}